import { Router } from "@frui.ts/screens";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import ConfirmationService from "services/confirmationService";
import EventBus from "services/eventBus";
import NotificationService from "services/notificationService";
import SecurityService from "services/securityService";
import EnforcementTabletRepository from "repositories/enforcementTabletRepository";
import EnforcementTabletResponse from "entities/enforcementTabletResponse";
import ListViewModel from "../../listViewModel";
import EnforcementTabletDetailViewModel from "./enforcementTabletDetailViewModel";
import IncludeDeletedPaginatedRequest from "entities/includeDeletedPaginatedRequest";
import { bound } from "@frui.ts/helpers";
import EnforcementTabletCreateViewModel from "./enforcementTabletCreateViewModel";

const navigationName = "tablets";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [EnforcementTabletCreateViewModel, EnforcementTabletDetailViewModel],
})
export default class EnforcementTabletsViewModel extends ListViewModel<
  EnforcementTabletResponse,
  EnforcementTabletDetailViewModel,
  EnforcementTabletCreateViewModel,
  IncludeDeletedPaginatedRequest
> {
  readonly modelName = "enforcementTablet";

  @bound
  allowItemDetail(item: EnforcementTabletResponse) {
    return !item.isDeleted;
  }

  @bound
  allowItemDelete(item: EnforcementTabletResponse) {
    return !item.isDeleted;
  }

  constructor(
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected notificationService: NotificationService,
    protected confirmationService: ConfirmationService,
    protected repository: EnforcementTabletRepository,
    protected securityService: SecurityService,
    protected createViewModelFactory: () => EnforcementTabletCreateViewModel,
    protected detailViewModelFactory: ReturnType<typeof EnforcementTabletDetailViewModel.Factory>
  ) {
    super();
    this.navigationName = navigationName;
  }

  protected createFilter(): IncludeDeletedPaginatedRequest {
    return new IncludeDeletedPaginatedRequest();
  }

  protected fetchData() {
    const { limit, offset } = this.pagingFilter;
    return this.repository.getAll({ ...this.appliedFilter, limit, offset });
  }

  delete(item: EnforcementTabletResponse): any {
    return this.repository.delete(item.id);
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.enforcement, `enforcementTablets.${code}`, size);
  }
}
